export default __webpack_public_path__ + "static/media/resource.svg";